import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d3526b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leadangel_info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sell_agree" }, " 판매 동의 "),
  /*#__PURE__*/_createElementVNode("div", { class: "info_title" }, [
    /*#__PURE__*/_createTextVNode(" 리드엔젤이 본인참여금을 입금하면"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 클럽딜이 열립니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "sub_message" }, [
    /*#__PURE__*/_createTextVNode(" 클럽딜이 열린 후에는 판매 가격을 변경할 수 없으며"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 클럽딜 진행 상황에 따라 판매 규모 협의는 가능합니다. ")
  ])
], -1))
const _hoisted_6 = { class: "space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "right_btn btn_groups",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendRequest && _ctx.sendRequest(...args)))
          }, " 확인 ")
        ])
      ])
    ])
  ]))
}